import React from "react";
import {Outlet ,Navigate} from "react-router-dom";
import { AppRoutes } from "../constants";
import InformationFormLayout from "./PatientForm/InformationFormLayout";
import ClientPage from "./ClientPage/ClientPage";
import AdjusterList from "./Insurance/AdjusterList";
import Invoice from "./Invoice";
import AppointmentPdf from "./appointmentPdf";
import OpenAccessPatientForm from "../components/OpenAccess/OpanAccessPatientForm"
import NewEntries from "../components/NewEntries/NewEntries";
import ViewDetails from "../components/NewEntries/ViewDetails";
import Profile from "../components/Profile/Profile";
import HospitalManagement from "./Hospital/HospitalManagement";
import DoctorsManagement from "./Physician/DoctorsManagement";
import ServicesPage from "./Services/ServicesPage";
import AvailabilityManagement from "./Availability/AvailabilityManagement";
const Home = React.lazy(() => import("../pages/Homepage"));
const Sample = React.lazy(() => import("../pages/Sample"));
const Register = React.lazy(() => import("../pages/Register"));
const NewUser = React.lazy(() => import("./NewUser/NewUser"));
const Users = React.lazy(() => import("./NewUser/users"));
const AdminLayout = React.lazy(() => import("../layouts/AdminLayout/AdminLayout"));
const ForgetPassword =  React.lazy(() => import("../pages/ForgetPassword/ForgetPassword"));
const Insurance =  React.lazy(() => import("../pages/Insurance/Insurancecomp"));
const Dashborad = React.lazy(() => import("../pages/Dashboard/Dashborad"));
const Doctors = React.lazy(() => import("../pages/Doctors/doctors"));
export const routes = (token) => [
  {
    path: AppRoutes.INVOICE,
    element: !token ? <Outlet /> :<Invoice  />,
  },
  {
    path: AppRoutes.APPOINTMENTPDF,
    element: !token ? <Outlet /> :<AppointmentPdf  />,
  },
  {
    path: AppRoutes.OPEN_ACCESS_PATIENT_FORM,
    element:  <OpenAccessPatientForm  />,
  },
  {
    element: !token ? <Outlet /> :<Navigate to={AppRoutes.DASHBOARD} />,
    children: [
      {
        path: AppRoutes.HOME,
        element: <Home />,
      },
      {
        path: AppRoutes.FORGET_PASSWORD,
        element: <ForgetPassword />,
      },
    ],
  },
  {
    element: token ? <AdminLayout />:<Navigate to={AppRoutes.HOME} />,
   children:[
    {
      path: AppRoutes.DASHBOARD,
      element: <Dashborad/>,
    },
    {
      path: AppRoutes.DASHBOARD_CAT,
      element: <Dashborad/>,
    },
    {
      path:AppRoutes.PATIENT_DETAILS,
      element:<InformationFormLayout/>
    },
    {
      path: AppRoutes.SIGNUP,
      element: <Register />,
    },
    {
      path:AppRoutes.PATIENT_INFO,
      element:<ClientPage/>
    },
    {
      path: AppRoutes.NEWUSER,
      element: <NewUser/>,
    },
    {
      path: AppRoutes.USERS,
      element: <Users/>,
    },
    {
      path: AppRoutes.INSURANCE_COMPANIES,
      element: <Insurance/>,
    },
    {
      path: AppRoutes.COMPANIES_ADJUSTERS,
      element: <AdjusterList/>,
    },
    // {
    //   path: AppRoutes.DOCTORS,
    //   element: <Doctors/>,
    // },
    {
      path: AppRoutes.SAMPLE,
      element: <Sample/>,
    },
    {
      path: AppRoutes.HOSPITAL,
      element: <HospitalManagement/>,
    },
    {
      path: AppRoutes.SERVICES,
      element: < ServicesPage />,
    },
    {
      path: AppRoutes.PHYSICIAN,
      element: < DoctorsManagement/>,
    },
    {
      path: AppRoutes.AVAILABILITY,
      element: <AvailabilityManagement/>,
    },
    {
      path: AppRoutes.NEW_ENTRIES,
      element: <NewEntries/>,
    },
    {
      path: AppRoutes.NEW_ENTRIES_DETAILS,
      element: <ViewDetails/>,
    },
    {
      path: AppRoutes.USER_PROFILE,
      element: <Profile/>,
    }
   ]
  },
];